<i18n>
{
  "en": {
    "title": "Company Performance Highlights 2017-2018",
    "description": "In 2017 Schneider Electric launched more 100 new products, including Masterpact MTZ, Galaxy VM, Compact NSXm, and SM6; made critical energy and software acquisitions, including IGE+XAO Group, Aveva, and ASCO Power Technologies; and delivered growth for shareholders.",
    "companyPerformance": {
      "section": "&nbsp;",
      "title": "Company Performance",
      "overview": {
        "quote": {
          "para": "In working for a more sustainable world, we not only ensure a healthier planet for future generations, we also promote innovation and prosperity here and now. What’s good for the climate is good for the economy.",
          "title": "Chairman & CEO, Schneider Electric"
        },
        "txt": {
          "title": "Sustainable growth",
          "p1": "It was a great year for Schneider Electric, with healthy performance on our 2015 – 2017 Planet &amp; Society barometer and strong growth for our business.",
          "p2": "Our sales accelerated, boosted by the delivery of complete solutions of efficiency and productivity and the adoption of EcoStruxure<sup>&trade;</sup> as the platform of integration and collaboration.",
          "p3": "We increased organic revenue 3.2 percent, launched more than 100 new products, and acquired new companies that strengthen our position as the global specialist in energy management and automation."
        }
      }
    }
  },
  "fr": {
    "title": "Company Performance Highlights 2017-2018",
    "description": "In 2017 Schneider Electric launched more 100 new products, including Masterpact MTZ, Galaxy VM, Compact NSXm, and SM6; made critical energy and software acquisitions, including IGE+XAO Group, Aveva, and ASCO Power Technologies; and delivered growth for shareholders.",
    "companyPerformance": {
      "section": "&nbsp;",
      "title": "Performance de l’Entreprise",
      "overview": {
        "quote": {
          "para": "En œuvrant pour un monde plus durable, nous voulons léguer une planète en bonne santé aux générations futures, mais surtout, nous promouvons l’innovation et la prospérité, ici et maintenant. Ce qui est bon pour le climat est bon pour l’économie.",
          "title": "Président Directeur général Schneider Electric"
        },
        "txt": {
          "title": "Croissance durable",
          "p1": "L'année écoulée fut excellente pour Schneider Electric, marquée par une excellente performance de notre baromètre Planète et Société et une importante croissance de notre activité.",
          "p2": "Stimulées par le déploiement de solutions d’efficacité et de production complètes et par l’adoption d’EcoStruxure en tant que plateforme d'intégration et de collaboration, nos ventes ont progressé.",
          "p3": "Notre chiffre d'affaires est en hausse de +3,2%, nous avons lancé plus de 100 nouveaux produits et continué d'optimiser notre portefeuille ce qui renforce notre position de leader de la gestion de l'énergie et des automatismes."
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('@/assets/img/homepage/company-performance-low.jpg')" :hiResSrc="require('@/assets/img/homepage/company-performance.jpg')" chapter="06" :section="$t('companyPerformance.section')" :title="$t('companyPerformance.title')" :grayBG="true" />

    <section class="m-b-120">
      <Quote :photo="require('@/assets/img/our-customers/introduction-welcome-quote-2.jpg')" name="Jean-Pascal Tricoire" :title="$t('companyPerformance.overview.quote.title')">
        <div v-html="$t('companyPerformance.overview.quote.para')"></div>
      </Quote>
    </section>

    <section class="m-b-120 m-t-120">
      <Txt>
        <h2 id="sustainablegrowth" v-html="$t('companyPerformance.overview.txt.title')"/>
        <p v-html="$t('companyPerformance.overview.txt.p1')"/>
        <p v-html="$t('companyPerformance.overview.txt.p2')"/>
        <p v-html="$t('companyPerformance.overview.txt.p3')"/>
      </Txt>
    </section>

    <section class="m-b-120 m-t-120">
      <ImageFull>
        <img src="@/assets/img/company-performance/Innovation-hub-15.jpg" />
      </ImageFull>
    </section>

   <div class="l-content">
      <FooterNav
        nextRoute="CompanyPerformance_YearInReview"
        prevRoute="Outreach_SchneiderElectricFoundation" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import References from '@/components/References'
import Reference from '@/components/Reference'
import YouTubeVideo from '@/components/YouTubeVideo'
import ImageFull from '@/components/ImageFull'

export default {
  name: 'CompanyPerformance_Overview',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    References,
    Reference,
    YouTubeVideo,
    ImageFull
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company-performance/overview.vue